{
  "columns": [],
  "buttons": [],
  "apiDetails": "mass-adjustment-list.json",
  "pageName": "invoiceBatchResultList",
  "orderByColumn": ["modifiedDate"],
  "orderBy": ["desc"]
}
